import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import axios from "axios";
import "react-image-crop/dist/ReactCrop.css";
import styles from "./ImageUploader.module.scss";
import { toast } from "react-toastify";
import api from "../../libs/api";
import Loader from "react-loader-spinner";

import { ReactComponent as PencilIcon } from "../../assets/images/pencil-icon.svg";
import uploadPhoto from "../../assets/images/upload-photo.svg";

const ImageUploader = ({ src = "", onChange }) => {
  const [srcUrl, setSrcUrl] = useState(src);

  const [file, setFile] = useState();
  const [imageRef, setImageRef] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [crop, setCrop] = useState({
    unit: "%",
    width: 30,
    aspect: 1,
  });

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSrcUrl(null);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setFile(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onImageLoaded = (image) => {
    console.log("image loaded!");
    setImageRef(image);
  };

  const onCropComplete = async () => {
    try {
      if (imageRef && crop.width && crop.height) {
        setIsUploading(true);

        const { blob } = await getCroppedImg(imageRef, crop, "newFile.jpeg");

        const {
          data: { url: signedS3Url },
        } = await api.get("/s3/signedurl", {
          params: {
            type: "image/jpeg",
            encoding: "base64",
            extension: "jpg",
          },
        });

        await uploadImage(blob, signedS3Url);

        const newSrc = signedS3Url.split("?")[0];

        setSrcUrl(newSrc);
        setIsUploading(false);

        if (onChange) {
          onChange(newSrc);
        }
      }
    } catch (error) {
      setIsUploading(false);
      toast.error("An error occurred uploading your photo. Please try again.");
    }
  };

  const onCropChange = (crop, percentCrop) => {
    setCrop(crop);
  };

  return (
    <div className={styles.ImageUploader} data-testid="ImageUploader">
      <div className="py-2 position-relative">
        {(srcUrl || !file) && (
          <>
            <figure>
              <div className={styles.ImageContainer}>
                {srcUrl ? (
                  <div
                    className={`${styles.pencilIcon} d-flex align-items-center justify-content-center`}
                  >
                    <PencilIcon />
                  </div>
                ) : null}
                <img
                  src={srcUrl || uploadPhoto}
                  alt="profile"
                  className="d-block"
                  width="165"
                  height="165"
                  data-testid="ImageTag"
                />
              </div>
            </figure>
            <input type="file" accept="image/*" onChange={onSelectFile} />
          </>
        )}
        {file && !srcUrl && (
          <div className="d-flex flex-column">
            <ReactCrop
              src={file}
              crop={crop}
              circularCrop
              onImageLoaded={onImageLoaded}
              // onComplete={onCropComplete}
              onChange={onCropChange}
            />
            {isUploading ? (
              <Loader type="ThreeDots" color="#CCC" height={10} width={30} />
            ) : (
              <button type="button" className="btn btn-dark mt-2" onClick={onCropComplete}>
                DONE
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

ImageUploader.propTypes = {};

ImageUploader.defaultProps = {};

export const getCroppedImg = (image, crop, fileName) => {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        //reject(new Error('Canvas is empty'));
        console.error("Canvas is empty");
        reject(new Error("empty!"));
        return;
      }
      blob.name = fileName;
      // window.URL.revokeObjectURL(this.fileUrl);
      const fileUrl = window.URL.createObjectURL(blob);
      console.log(blob);
      console.log(fileUrl);
      resolve({
        fileUrl,
        blob,
      });
    }, "image/jpeg");
  });
};

export const uploadImage = async (imageBlob, url) => {
  const buffer = await imageBlob.arrayBuffer();
  await axios.put(url, buffer, {
    headers: {
      "Content-Type": "image/jpeg",
      "Content-Encoding": "base64",
    },
  });
};

export default ImageUploader;
